import { Spin } from 'antd'
import { cn } from '@/lib/utils'

interface LoadingProps {
  className?: string
  text?: string
  size?: 'sm' | 'md' | 'lg'
}

export function Loading({ className, text, size = 'md' }: LoadingProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-2', className)}>
      <Spin size={size === 'sm' ? 'small' : size === 'lg' ? 'large' : 'default'} />
      {text && (
        <span className="text-sm text-[var(--color-text-secondary)]">{text}</span>
      )}
    </div>
  )
}

export function PageLoading({ text }: { text?: string }) {
  return (
    <div className="flex min-h-[400px] items-center justify-center">
      <Loading size="lg" text={text} />
    </div>
  )
}
